/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: BpSelectFieldWrapper.tsx
 * Project: mle-client
 * Committed last: 2021/11/9 @ 1922
 * ---
 */

import React from 'react';
import {FormGroup} from '@blueprintjs/core';
import {Field, FieldAttributes} from 'formik';
import {HasName} from '../../../common/utils';

export interface SelectWrapperProps<T extends HasName> {
  name: string;
  label: string;
  required: boolean;
  className?: string;
  child: JSX.Element;
}

export const BpSelectFieldWrapper = <T extends HasName>(props: SelectWrapperProps<T>) => (
  <Field name={ props.name }>
    { ({ meta }: FieldAttributes<any>) => (
        <FormGroup
            className={props.className}
            helperText={meta.touched && meta.error ?
                <div>{meta.error}</div> : ''}
            intent={meta.touched && meta.error ? 'danger' : 'none'}
            label={props.label}
        >
          {
            props.child
          }
        </FormGroup>
    ) }
  </Field>
);
